export default __webpack_public_path__ + "static/media/closeDark.ce9624b0.svg";